import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-searchresultlistitem',
  templateUrl: './searchresultlistitem.component.html',
  styleUrls: ['./searchresultlistitem.component.css']
})
export class SearchresultlistitemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/search/searchresultlistitem/searchresultlistitem.component.ts